module.exports = {"already_rated":"Du hast diesen Eintrag bereits bewertet","thanks_for_rating":"Vielen Dank für die Bewertung."};